import loadjs from 'loadjs';
import { expandCollapseManager } from '@wix/chat-web';
import { loadingScheduler } from '../loading-scheduler';
import wix from '../wix';

const loadConnectivityPrerequisiteScripts = ({ unpkgUrl }) => {
  return new Promise(resolve => {
    const files = [
      `${unpkgUrl}/firebase@5.7.3/firebase-app.js`,
      `${unpkgUrl}/firebase@5.7.3/firebase-auth.js`,
      `${unpkgUrl}/firebase@5.7.3/firebase-database.js`,
    ];
    loadjs(files, {
      async: false,
      numRetries: 3,
      before: (path, scriptEl) => {
        scriptEl.crossOrigin = 'anonymous';
      },
      success: () => {
        resolve();
      },
    });
  });
};

export const triggerInteractivity = () =>
  void loadingScheduler
    .onConnective()
    .then(loadingScheduler.triggerInteractivity);

const loadLazily = (unpkgUrl: string) => {
  void loadConnectivityPrerequisiteScripts({ unpkgUrl }).then(
    loadingScheduler.triggerConnectivity,
  );

  const triggerInteractivityHandler = () => {
    triggerInteractivity();

    window.removeEventListener('mouseover', triggerInteractivityHandler);
    expandCollapseManager.unregisterOnExpand(triggerInteractivityHandler);
  };

  window.addEventListener('mouseover', triggerInteractivityHandler);
  expandCollapseManager.registerOnExpand(triggerInteractivityHandler);
  window.setTimeout(triggerInteractivityHandler, 15e3);
};

const loadRegularly = () => {
  loadingScheduler.triggerConnectivity();

  if (window.requestIdleCallback) {
    window.requestIdleCallback(triggerInteractivity);
  }
  wix.onReady(triggerInteractivity);
};

export const loadChat = ({ widgetMode, unpkgUrl }) => {
  const isSiteMode = widgetMode === 'site';

  if (isSiteMode) {
    loadLazily(unpkgUrl);
  } else {
    loadRegularly();
  }
};
